module.exports = __webpack_public_path__ + "officialStatic/img/case-byd.67c53ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case-byd.png
// module id = mvXm
// module chunks = 0